import { DmmServiceMobile } from "./dmm-service";
import * as Styled from "./style";
import { Logo } from "~/components/blocks/layout/global-navi/common/logo";
import { DmmServiceDesktop } from "~/components/blocks/layout/global-navi/desktop/left/dmm-service";
import { useMatchMedia } from "~/hooks/use-match-media";

type MobileLeftProps = {
  isShowSearch: boolean;
  isShowDmmService: boolean;
  onHideSearch: () => void;
  onToggleDmmService: () => void;
  onCloseDmmService: () => void;
};

export const Left = (props: MobileLeftProps) => {
  const { isShowDmmService, isShowSearch, onToggleDmmService, onHideSearch, onCloseDmmService } = props;

  const { isSpSize } = useMatchMedia();

  return (
    <Styled.ButtonWrapper type="button" name="search" aria-label="search">
      {!isShowSearch && (
        <>
          {isSpSize ? (
            <>
              <Styled.MenuIcon
                name="union"
                color="GRAY900"
                size="L"
                isVisible={isShowDmmService}
                onClick={() => {
                  if (isShowSearch) onHideSearch();
                  onToggleDmmService();
                }}
              />
              {isShowDmmService && (
                <DmmServiceMobile isShowDmmService={isShowDmmService} onToggleDmmService={onToggleDmmService} />
              )}
              <Logo isShowDmmService={isShowDmmService} onCloseDmmService={onCloseDmmService} />
            </>
          ) : (
            <>
              <DmmServiceDesktop />
              <Logo isShowDmmService={isShowDmmService} onCloseDmmService={onCloseDmmService} />
            </>
          )}
        </>
      )}
    </Styled.ButtonWrapper>
  );
};
